/**
 * Floating mobile-first phone CTA — appears only when:
 *   1. The visitor's locale is SK or CZ (Slovaks/Czechs convert 3x better via
 *      phone calls than form submits — iFocus's biggest weapon)
 *   2. REACT_APP_CONTACT_PHONE_SK is configured (otherwise we hide the
 *      button entirely so it doesn't show a broken `tel:undefined` link)
 *   3. The viewport is mobile (≤768px) — desktop visitors prefer chat / email
 */
import { useEffect, useState } from "react";
import { Phone } from "lucide-react";

export const PhoneFloatingCTA = ({ language }) => {
  const phone = process.env.REACT_APP_CONTACT_PHONE_SK || "";
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const update = () => setIsMobile(window.innerWidth <= 768);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  if (!phone) return null;
  if (!["sk", "cs"].includes(language)) return null;
  if (!isMobile) return null;

  const label = language === "cs" ? "Zavolat" : "Zavolať";
  return (
    <a
      href={`tel:${phone.replace(/\s/g, "")}`}
      data-testid="phone-floating-cta"
      className="fixed bottom-4 right-4 z-50 flex items-center gap-2 px-4 py-3 bg-[#FFE600] text-black font-black uppercase rounded-full shadow-lg hover:scale-105 active:scale-95 transition-transform"
      aria-label={`${label} ${phone}`}
    >
      <Phone className="w-5 h-5 animate-pulse" />
      <span className="text-sm">{label}</span>
    </a>
  );
};
